"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import { motion } from "framer-motion";
import { howItWorksSteps } from "./crm.data";
import Image from "next/image";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
export default function HowItWorks() {
  const $ = _c(22);
  const desktopAnimations = useDesktopAnimations();
  let t0;
  if ($[0] !== desktopAnimations) {
    t0 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[0] = desktopAnimations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== desktopAnimations) {
    t1 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== desktopAnimations) {
    t2 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 0.6,
      ease
    };
    t4 = {
      once: true
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t0 || $[9] !== t1 || $[10] !== t2) {
    t5 = <motion.h2 initial={t0} whileInView={t1} animate={t2} transition={t3} viewport={t4} className="font-poppins text-[1.9rem] sm:text-[2.25rem] lg:text-[2.5rem] font-bold text-[#141047] mb-5 leading-tight dark:text-white">How Our Doctor Appointment Booking CRM Works – A Complete Guide</motion.h2>;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="text-gray-500 text-base leading-relaxed dark:text-gray-400">Our doctor booking CRM helps patients easily find doctors, book visits, and manage appointments for a smooth and simple healthcare experience.</p>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5) {
    t7 = <div className="text-center max-w-3xl mx-auto mb-14">{t5}{t6}</div>;
    $[13] = t5;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== desktopAnimations) {
    t8 = howItWorksSteps.map((step, idx) => {
      const isMiddleCard = idx === 1 || idx === 4;
      return <motion.div key={step.title} initial={desktopAnimations ? {
        opacity: 0,
        y: 30
      } : false} whileInView={desktopAnimations ? {
        opacity: 1,
        y: 0
      } : undefined} animate={desktopAnimations ? undefined : {
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: idx % 3 * 0.1,
        ease
      }} viewport={{
        once: true
      }} className={`group relative rounded-[22px] p-8 md:p-9 shadow-[0_8px_30px_rgba(0,0,0,0.03)] hover:shadow-[0_16px_40px_rgba(0,0,0,0.08)] hover:-translate-y-2 transition-all duration-300 overflow-hidden ${step.gradient} dark:bg-gray-800 dark:shadow-[0_8px_30px_rgba(0,0,0,0.4)] ${isMiddleCard ? "lg:-mt-6 lg:mb-6" : ""}`}><div className="mb-6 flex items-start justify-start"><Image src={step.image} alt={step.alt} width={56} height={56} className="h-14 w-14 object-contain" /></div><h3 className="font-poppins text-xl font-bold text-[#141047] dark:text-white mb-3 tracking-tight">{step.title}</h3><p className="text-[#6b7280] dark:text-gray-300 text-[15px] leading-relaxed">{step.description}</p><span aria-hidden={true} className="absolute bottom-0 left-0 h-1 w-0 bg-[linear-gradient(135deg,#9100ff_0%,#3663ff_54%,#00e2ff_100%)] transition-[width] ease-[cubic-bezier(0.17,0.85,0.438,0.99)] duration-[1200ms] group-hover:w-full" /></motion.div>;
    });
    $[15] = desktopAnimations;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-8 items-start pt-6">{t8}</div>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t7 || $[20] !== t9) {
    t10 = <section className="bg-[#fafbfc] py-16 md:py-24 px-6 font-sans dark:bg-gray-900"><div className="max-w-7xl mx-auto">{t7}{t9}</div></section>;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}